import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";

export type DiagnosticScalingPolicy = {
  enabled: boolean;
  idle_workers: number;
  max_workers: number;
  shrink_after_seconds: number;
  observation_seconds: number;
};

type CapacityChange = {
  request_id: string;
  deployment_uid: string;
  previous_operation: string | null;
  original: number;
  target: number;
  started_at: string;
};

type ChangingCapacity = CapacityChange & {
  phase: "increasing" | "draining" | "decreasing";
};

export type DiagnosticScalingOperation =
  | { phase: "stable" }
  | ChangingCapacity
  | {
      phase: "cancelling";
      request_id: string;
      change: ChangingCapacity;
      deployment_uid: string;
      previous_operation: string | null;
      target: number;
    };

export type DiagnosticScalingStatus = {
  policy: DiagnosticScalingPolicy;
  revision: string;
  operation: DiagnosticScalingOperation;
  eligible_since: string | null;
  last_observed_at: string | null;
};

export async function getDiagnosticScaling(): Promise<DiagnosticScalingStatus> {
  return (await apiClient.get<DiagnosticScalingStatus>(apiRoutes.admin.diagnosticScaling)).data;
}

export async function saveDiagnosticScaling(
  revision: string,
  policy: DiagnosticScalingPolicy,
): Promise<DiagnosticScalingStatus> {
  return (
    await apiClient.put<DiagnosticScalingStatus>(apiRoutes.admin.diagnosticScaling, {
      revision,
      policy,
    })
  ).data;
}
